export default __webpack_public_path__ + "static/Symbox-f7578f677a34f63b78e93b99bfc56673.png";